import { useCallback, useMemo, useState } from 'react';

const useFormValidation = (form, getErrorMessage) => {
    const [errors, setErrors] = useState(Object.keys(form).reduce((acc, cur) => ({ ...acc, [cur]: '' }), {}));

    const validate = useCallback(
        (key, value, form) => {
            const errorMessage = getErrorMessage(key, value, form);
            setErrors((errors) => {
                return {
                    ...errors,
                    [key]: errorMessage,
                };
            });
        },
        [getErrorMessage]
    );

    const validateAll = useCallback(() => {
        return !Boolean(
            Object.keys(errors)
                .map((key) => {
                    validate(key, form[key], form);
                    return getErrorMessage(key, form[key], form) || '';
                })
                .reduce((acc, cur) => {
                    const getValue = (item) => {
                        if (typeof item === 'string') {
                            return item;
                        } else if (Array.isArray(item)) {
                            return item.map(getValue).reduce((a, c) => a + c, '');
                        } else if (typeof item === 'object') {
                            return Object.values(item).reduce((a, c) => a + c, '');
                        }
                    };

                    return acc + getValue(cur);
                }, '')
        );
    }, [errors, form, getErrorMessage, validate]);

    return useMemo(
        () => ({
            errors,
            validate,
            validateAll,
        }),
        [errors, validate, validateAll]
    );
};

export default useFormValidation;
